import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { RouterPaths } from "./app/appConstants.js";
import { makeSelectAppInited } from "./app/appSelectors";
import PageError from "./app/PageError.jsx";
import RoutePage from "./app/RoutePage";
import { isClientAndroidNative } from "./components/ClientInfo/ClientInfo";
import Bonus from "./modules/Bonus/components/BonusProvider.jsx";
import { GlobalStyles } from "./modules/GlobalStyles/GlobalStyles";
import Modals from "./modules/Modals/Modals";
import NotificationsContainer from "./modules/Notifications/NotificationsContainer";
import Zendesk from "./modules/Zendesk/Zendesk";
import ExponeaProvider from "./providers/ExponeaProvider";
import { useLangContext } from "./providers/LangProvider/LangProviderContext.js";

function WebApp(props) {
    const {
        isInited,
    } = props;

    const { lang } = useLangContext();

    // check TWA
    if (isClientAndroidNative) {
        document.location.href = RouterPaths.app;
    }

    return <>
        {
            isInited && lang && <>
                <Zendesk>
                    <Bonus>
                        <GlobalStyles/>
                        <Modals/>
                        <NotificationsContainer/>
                        <RoutePage/>
                        <ExponeaProvider/>
                    </Bonus>
                </Zendesk>
            </>
        }
        {
            isInited && !lang && <>
                <GlobalStyles/>
                <PageError
                    code={500}
                    headerText={'Service unavailable'}
                    description={'Sorry, the service is not available'}
                />
            </>
        }
    </>;
}

const mapStateToProps = createStructuredSelector({
    isInited: makeSelectAppInited(),
});

export default connect(mapStateToProps)(WebApp);
